import { ORPCError } from '@orpc/client';
import { PriceBreakOfferChangedDataSchema } from '@erp/shared-types';

/**
 * Whether an `applyPriceBreak` failure is the server saying the offer the
 * board showed no longer holds: a CONFLICT carrying
 * `data.code = "PRICE_BREAK_OFFER_CHANGED"`. The board answers it by
 * dismissing that option's nudge until the next replenishment run rather than
 * reporting a failed save.
 */
export function isPriceBreakOfferChanged(error: unknown): boolean {
  return (
    error instanceof ORPCError &&
    error.code === 'CONFLICT' &&
    PriceBreakOfferChangedDataSchema.safeParse(error.data).success
  );
}
